export const ACC_SCHEDULE_SEATS = 21;

export const ACC_TIME_SLOT = 2;

//(duplicate) we have this defination in both public and programs
export type StandardFourTimeZoneId = 1 | 3 | 5 | 7;

//0=Mon, 1=Tue, 2=Wed, 3=Thu, 4=Fri, 5=Sat, 6=Sun
export type WeekdayIndex = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export const DAY_INDICES: WeekdayIndex[] = [0, 1, 2, 3, 4, 5, 6];

export const HOURS_ET = [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22];

export const HOURNAMES_MAP: Record<STANDARD_FOUR_TIME_ZONE_ID, string[]> = {
	1: ['6am-8am', '7am-9am', '8am-10am', '9am-11am', '10am-12pm', '11am-1pm', '12pm-2pm', '1pm-3pm', '2pm-4pm', '3pm-5pm', '4pm-6pm', '5pm-7pm', '6pm-8pm', '7pm-9pm', '8pm-10pm', '9pm-11pm', '10pm-12am'],
	5: ['5am-7am', '6am-8am', '7am-9am', '8am-10am', '9am-11am', '10am-12pm', '11am-1pm', '12pm-2pm', '1pm-3pm', '2pm-4pm', '3pm-5pm', '4pm-6pm', '5pm-7pm', '6pm-8pm', '7pm-9pm', '8pm-10pm', '9pm-11pm'],
	7: ['4am-6am', '5am-7am', '6am-8am', '7am-9am', '8am-10am', '9am-11am', '10am-12pm', '11am-1pm', '12pm-2pm', '1pm-3pm', '2pm-4pm', '3pm-5pm', '4pm-6pm', '5pm-7pm', '6pm-8pm', '7pm-9pm', '8pm-10pm'],
	3: ['3am-5am', '4am-6am', '5am-7am', '6am-8am', '7am-9am', '8am-10am', '9am-11am', '10am-12pm', '11am-1pm', '12pm-2pm', '1pm-3pm', '2pm-4pm', '3pm-5pm', '4pm-6pm', '5pm-7pm', '6pm-8pm', '7pm-9pm'],
};

//(duplicate) we have this defination in both public(SelectedSlots) and programs (schedule.ts) 
export interface MeetingSlots {
	mon: string,
	tue: string,
	wed: string,
	thu: string,
	fri: string,
	sat: string,
	sun: string,
}

export const SLOTS_DAY_MAP: Record<WeekdayIndex, keyof MeetingSlots> = {
	0: 'mon',
	1: 'tue',
	2: 'wed',
	3: 'thu',
	4: 'fri',
	5: 'sat',
	6: 'sun'
};

// These are a few values from the timezone table, showing timeZoneId and their corresponding names
/**
 * A mapping of numeric timezone identifiers to their corresponding IANA timezone strings.
 *
 * The keys represent internal numeric codes for US timezones, and the values are the
 * respective IANA timezone names.
 *
 * - `1`: Eastern Time (`America/New_York`)
 * - `5`: Central Time (`America/Chicago`)
 * - `7`: Mountain Time (`America/Denver`)
 * - `3`: Pacific Time (`America/Los_Angeles`)
 *
 * @example
 * ```typescript
 * const tz = TIMEZONE_MAP[1]; // "America/New_York"
 * ```
 */
export const TIMEZONE_MAP = {
	1: 'America/New_York',
	5: 'America/Chicago',
	7: 'America/Denver',
	3: 'America/Los_Angeles'
};

export enum STANDARD_FOUR_TIME_ZONE_ID {
	Eastern = 1,
	Pacific = 3,
	Central = 5,
	Mountain = 7,
}
export const STANDARD_FOUR_TIME_ZONE_NAME = {
	[STANDARD_FOUR_TIME_ZONE_ID.Eastern]: 'Eastern', //America/New_York
	[STANDARD_FOUR_TIME_ZONE_ID.Pacific]: 'Pacific',//America/Los_Angeles
	[STANDARD_FOUR_TIME_ZONE_ID.Central]: 'Central',//America/Chicago
	[STANDARD_FOUR_TIME_ZONE_ID.Mountain]: 'Mountain',//America/Denver
}
type USStandardZoneLabel = "Eastern" | "Central" | "Mountain" | "Pacific";

export const TimeZoneWiseStandardZone: Record<string, USStandardZoneLabel> = {
	[TIMEZONE_MAP[1]]: STANDARD_FOUR_TIME_ZONE_NAME[STANDARD_FOUR_TIME_ZONE_ID.Eastern] as USStandardZoneLabel,
	[TIMEZONE_MAP[5]]: STANDARD_FOUR_TIME_ZONE_NAME[STANDARD_FOUR_TIME_ZONE_ID.Central] as USStandardZoneLabel,
	[TIMEZONE_MAP[7]]: STANDARD_FOUR_TIME_ZONE_NAME[STANDARD_FOUR_TIME_ZONE_ID.Mountain] as USStandardZoneLabel,
	[TIMEZONE_MAP[3]]: STANDARD_FOUR_TIME_ZONE_NAME[STANDARD_FOUR_TIME_ZONE_ID.Pacific] as USStandardZoneLabel,
};
